import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/useAppStore';
import { getPusher } from '../../lib/pusher';
import { gustavoApi } from '../../store/api/gustavoApi';

/**
 * Enciende el puntito de Gustavo EN EL MOMENTO en que llega un aviso.
 *
 * Sin esto el badge aparecía recién en el siguiente poll (2 min) o recargando la
 * página entera — y como el aviso por el CRM es hoy el mitigante de la ventana de
 * WhatsApp cerrada (77 de 88 agentes), esperar dos minutos lo volvía inútil.
 *
 * Reusa `private-user-{id}`, el canal que el CRM ya tiene suscrito para el chat, los
 * avisos de Phylax y los bugs. NO hace `unsubscribe` en el cleanup: el canal es
 * compartido y darlo de baja acá dejaría sordos a los otros hooks. Solo se desata el
 * handler propio.
 */
export function useGustavoNoticeLive() {
  const accessToken = useAppSelector((s) => s.auth.accessToken);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!accessToken) return;
    let userId: string;
    try {
      userId = JSON.parse(atob(accessToken.split('.')[1])).sub as string;
    } catch {
      return;
    }

    const pusher = getPusher(accessToken);
    const channel = pusher.subscribe(`private-user-${userId}`);

    // Solo invalidamos el tag: el contador y el texto salen del backend, así que no
    // hay dos fuentes de verdad que se puedan desincronizar.
    const onNotice = () => {
      dispatch(gustavoApi.util.invalidateTags(['GustavoNotices']));
    };

    channel.bind('gustavo.notice', onNotice);
    return () => { channel.unbind('gustavo.notice', onNotice); };
  }, [accessToken, dispatch]);
}
